'use strict';

import Lenis from '@studio-freight/lenis';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class InertialScroll {
	constructor() { }

	render() {
		// イージング関数
		const easeOutQuart = (x) => 1 - Math.pow(1 - x, 4);
		const lenis = new Lenis({
			lerp: 0.1,          // 慣性の強さ
			duration: 0.5,       // スクロールアニメーションの時間
			easing: easeOutQuart, // イージング関数
			smoothWheel: true,   // ホイールスクロールもスムーズにする
		});

		// ScrollTrigger と同期させる。これが無いとスクラブ系のアニメが
		// Lenis の補間に追従できずカクつく
		app.lenis = lenis;
		lenis.on('scroll', ScrollTrigger.update);
		gsap.ticker.lagSmoothing(0);

		// 一度だけパララックス対象の要素をキャッシュし、表示状態を追加
		const parallaxElements = Array.from(document.querySelectorAll('.js_parallax_image')).map((element) => {
			const speed = parseFloat(element.getAttribute('data-speed')) || -0.08;
			return { element, speed, isVisible: false };
		});

		// Intersection Observerの設定
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				// 対応する要素オブジェクトを見つける
				const targetElement = parallaxElements.find(item => item.element === entry.target);
				if (targetElement) {
					// 要素の表示状態を更新
					targetElement.isVisible = entry.isIntersecting;
				}
			});
		}, {
			rootMargin: '50px', // 表示判定の余白を設定（早めに効果を開始するため）
			threshold: 0.01     // わずかでも表示されたら検知
		});

		// 全ての要素をIntersection Observerに登録
		parallaxElements.forEach(item => {
			observer.observe(item.element);
		});

		// スクロール状態の変数 - 既存コードとの競合を避けるため変数名を変更
		let parallaxLastScrollY = 0;
		let parallaxTicking = false;

		function updateParallax() {
			const scrollY = lenis.scroll;

			// 表示中の要素のみパララックス効果を適用
			parallaxElements.forEach(({ element, speed, isVisible }) => {
				if (isVisible) {
					element.style.transform = `translateY(${scrollY * speed}px)`;
				}
			});

			parallaxTicking = false;
		}

		// １つの requestAnimationFrame ループ内で全ての処理を行う
		function raf(time) {
			// Lenis のスクロール更新
			lenis.raf(time);

			// スクロール位置が変わった時だけ処理を実行
			const currentScrollY = lenis.scroll;
			if (parallaxLastScrollY !== currentScrollY && !parallaxTicking) {
				requestAnimationFrame(updateParallax);
				parallaxTicking = true;
				parallaxLastScrollY = currentScrollY;
			}

			requestAnimationFrame(raf);
		}
		requestAnimationFrame(raf);






		// ここから波
		const clipElements = document.querySelectorAll('.js_soloClip_inner');
		let windowWidth = window.innerWidth; // ウィンドウサイズを保持

		function updateClipPath(velocity) {
			const speed = Math.abs(velocity);
			const isScrollingDown = velocity > 0;

			let amplitude = Math.min(2 + speed * app.Util.fontsize() * 0.2, app.Util.fontsize() * 4);
			const step = Math.max(windowWidth / 31, 30); // 最小ステップサイズを確保

			clipElements.forEach((clipElement) => {
				let points = [];

				for (let x = 0; x <= windowWidth; x += step) {
					let normalizedX = (x - windowWidth / 2) / windowWidth;
					let y = isScrollingDown
						? app.Util.fontsize() * 8 - amplitude * (1 - 4 * normalizedX ** 2)
						: app.Util.fontsize() * 8 + amplitude * (1 - 4 * normalizedX ** 2);

					points.push(`${x}px ${y}px`);
				}

				// **右端のポイントを適切に調整**
				const lastX = windowWidth;
				const lastY = points[points.length - 1].split(' ')[1];
				const firstY = points[0].split(' ')[1];

				points.push(`${lastX}px ${lastY}`, `${lastX}px ${app.Util.fontsize() * 12}px`, `0px ${app.Util.fontsize() * 12}px`);

				// 修正: 最後の点が右端に正しく揃うように調整
				clipElement.style.clipPath = `polygon(${points.join(', ')})`;
			});
		}

		// Lenis.js スクロールイベント
		let lastScrollY = 0; // 直前のスクロール位置を保持

		lenis.on('scroll', () => {
			let scrollY = lenis.scroll; // 現在のスクロール位置
			let velocity = scrollY - lastScrollY; // 変化量を計算（方向判定）
			updateClipPath(velocity);
			lastScrollY = scrollY; // 最新の位置を保存
		});

		// **リサイズイベントの追加**
		window.addEventListener('resize', () => {
			windowWidth = window.innerWidth; // 最新のウィンドウ幅を取得
			updateClipPath(0); // 速度0でリサイズ時も安定した形に
		});
		// ここまで波





	}
}

export default InertialScroll;
